/**
 * Sanitize a project name so that it only contains valid characters.
 */
export default function projectName(s: string) {
  return s
    .toLowerCase()
    .replace(/\W+/g, '-')
    .replace(/(-)\1/g, '-');
}
